/* eslint-disable */
import { take } from "redux-saga/effects";
import { httpPost } from "../../Utils/apis/apis";
import { previousUploadDeleteActionTypes } from "../actions/actionTypes";
import * as previousUploadDeleteActions from "../actions/previousUploadDeleteActions";
import { setToast } from "../actions/toastActions";
import { toastType, toastSeverity } from "../../Utils/config/toastConfig";
import { message } from "../../Utils/config/messages";
import { subdomain } from "../../components/Factory/Atoms/DataDisplay/DataGrid/helper/download.helper";
export function* getPreviousUploadDeleteSaga() {
  while (true) {
    const action = yield take(
      previousUploadDeleteActionTypes.GET_PREVIOUS_UPLOAD_DELETE
    );
    const { documentName, fileOperation, containerType } = action.payload;
    try {
      const url = `${process.env.DOCUMENT_HELPER}`;
      let header = {
        filename: documentName,
        type: containerType ? containerType : "generic",
        "file-operation": fileOperation,
        "process-file": "no",
        "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
        subdomain: subdomain,
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      yield httpPost(
        url,
        {
          method: "GET",
        },
        { headers: header }
      );
    } catch (e) {
      setToast({
        type: toastType.PREVIOUS_UPLOAD_SAGA,
        severity: toastSeverity.ERROR,
        message: message.PREVIOUS_UPLOAD_SAGA,
        status: true,
      });
      previousUploadDeleteActions.getPreviousUploadDeleteFailed({
        errorCode: "",
        message: "",
        status: false,
      });
    }
  }
}
